import React, { useContext, useEffect, useRef, useState } from "react";
import AccountNavBar from "../../NewComponents/AccountNavBar";

import { ReactComponent as SEARCHICON } from "../../assets/icons/search.svg";
import { ReactComponent as DOWN } from "../../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../../assets/icons/filter-up.svg"
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as DOWNLOAD } from "../../assets/icons/Download.svg";
import { ReactComponent as DATE } from "../../assets/icons/Date.svg";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { AuthContext } from "../../Context/AuthContext";
import { TransitionContext } from "../../Context/TransitionContext";
import { DataContext } from "../../Context/DataContext";
import NoData from "../../NewComponents/NoData";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import { ReactComponent as SORT_ASC } from "../../assets/icons/sort-asc.svg";
import { ReactComponent as SORT_DSC } from "../../assets/icons/sort-dsc.svg";
import { INVOICESTATUS } from "../../Data/statuses";
import { formatTotal } from "../../Data/Functions";
import DateFilter from "../Account/OrdersComponents/DateFilter";
import { ReactComponent as STATUS } from "../../assets/icons/Status.svg";
import SearchFilter from "../Account/OrdersComponents/SearchFilter";
import { ReactComponent as CHECK } from "../../assets/icons/check.svg";
import { ReactComponent as SEND } from "../../assets/icons/Send.svg";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal";
import { Configure, Pagination, SearchBox, useHits, useInstantSearch, useSearchBox, useSortBy } from "react-instantsearch-hooks-web";
import { checkFetchAlgoliaData, firestore } from "../../firebase.config";
import { Link } from "react-router-dom";
import QueryFilters from "../Account/OrdersComponents/QueryFilters";

const BackendInvoicesComponent = ({windowSize}) => {

    const { transitionTo } = useScreenTransition();

    const { setColor } = useContext(TransitionContext);
    const { userData } = useContext(DataContext);
    const { signedIn } = useContext(AuthContext);
  
  
    const [showFilter, setShowFilter] = useState("");
  
    const [filterStartTimestamp, setFilterStartTimestamp] = useState(null);
    const [filterEndTimestamp, setFilterEndTimestamp] = useState(null);
    const [datePeriod, setDatePeriod] = useState("custom");

    const [paymentFilter, setPaymentFilter] = useState("");
    const [selectedSendPayment, setSelectedSendPayment] = useState("");
    const [openInvoiceModal, setOpenInvoiceModal] = useState("");
    const [showDetailModal, setShowDetailModal] = useState("");

    let nextPointer = useRef();
    if (!nextPointer.current) nextPointer.current = null;

    const handleDownloadInvoice = (invoice) => {
      setOpenInvoiceModal(invoice);
    }

    useEffect(() => {
        setColor(true);
      }, [setColor]);

         const [localInvoices, setLocalInvoices] = useState([]);
  
    useEffect(()=> {
      if(!checkFetchAlgoliaData()){
        if( userData.id){
          firestore.collection("orderInvoices").orderBy("timestamp", "desc").get()
          .then(qSnap => {
            if(qSnap.empty){
              return;
            }
  
            setLocalInvoices(qSnap.docs.map(doc => ({...doc.data(), objectID: doc.id})));
          })
        }
      }
  
    }, 
    [userData])

    useEffect(() => {
        if(!signedIn || (userData && userData.role === "client")){
          return transitionTo("/");
        }
      }, [signedIn, userData]);


    const checkAnyFilterSelected = () => {
        if(filterStartTimestamp){
          return true;
        }
        if(filterEndTimestamp){
          return true;
        }
        if(paymentFilter !== ""){
          return true;
        }
        return false
    }

    const formatFilterDate = (date) => {
        return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    };
      
    const getSelectedDateText = () => {
        if(filterStartTimestamp){
            if(filterEndTimestamp){
            return formatFilterDate(new Date(filterStartTimestamp)) +  " - "
                + formatFilterDate(new Date(filterEndTimestamp));
            }else{
            return formatFilterDate(new Date(filterStartTimestamp)) +  " - "
                + formatFilterDate(new Date());
            }

        }else{
            return "Date";
        }
    }

    const formatDate = (timestamp, showTime = false) => {
        const date = new Date(timestamp);
    
        const splitted = date.toDateString().split(" ");
    
        const time = showTime ? (' @ ' + date.toTimeString().substr(0, 5)) : "";
    
        return (
          splitted[1] +
          " " +
          splitted[2] +
          ", " +
          splitted[3] + time
        );
      };

    const {hits} = useHits();
    const {status} = useInstantSearch();
    const {query} = useSearchBox();
    const [loading, setLoading] = useState(true);

    const items = [
      {
      Label: "Default",
      value: "orderInvoices"
      },
      {
      Label: "Date asc",
      value: "invoice_time_asc"
      },
      {
      Label: "Date dsc",
      value: "invoice_time_dsc"
      },
      {
      Label: "Status asc",
      value: "invoice_status_asc"
      },
      {
      Label: "Status dsc",
      value: "invoice_status_dsc"
      },
      {
      Label: "Email asc",
      value: "invoice_email_asc"
      },
      {
      Label: "Emaail dsc",
      value: "invoice_email_dsc"
      },
    ]
    const { currentRefinement, refine } = useSortBy({items: items, defaultRefinement: "invoice_time_dsc"});

    useEffect(() => {
      if(status === "loading" || status === "stalled"){
        setLoading(true);
      }else{
        setLoading(false);
      }
    }, [status])

    useEffect(() => {
      if(currentRefinement === "orderInvoices"){
        refine("invoice_time_dsc");
      }
    }, [currentRefinement])
 

  const [filters, setFilters] = useState("");
  
  useEffect(() => {
    let tempFilters = "";
    
    if(filterStartTimestamp && filterEndTimestamp){
      tempFilters += `${tempFilters === "" ? "" : " AND"} timestamp >= ${filterStartTimestamp} AND timestamp <= ${filterEndTimestamp}`
    }
    if(paymentFilter){
      tempFilters += `${tempFilters === "" ? "" : " AND"} status:${paymentFilter}`;
    }

    setFilters(tempFilters);
  }
  , [paymentFilter, filterStartTimestamp, filterEndTimestamp, userData])

  const TableDataComponent = ({hits}) => {

    if(hits.length === 0){
      return <tbody></tbody>;
    }

    return (
      <tbody>
      {hits.map(hit =>
      {
        const invoice = {...hit, id: hit.objectID}
        return (
        <tr key={invoice.id} onClick={(e) => transitionTo(`/office/invoice/${invoice.id}`, e)}>
            <td>
              <Link to={`/office/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
                  <p
                    className="accountDetailsText accountDetailsLink"
                >
                    {invoice.invoiceNumber}
                </p>
              </Link>
            </td>
            <td>
              <Link to={`/office/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
                <p className="accountDetailsText">
                    {invoice.billingPeriod ? invoice.billingPeriod : formatDate(invoice.timestamp)}
                </p>
              </Link>
            </td>
            <td>
              <Link to={`/office/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
                <p className="accountDetailsText">
                    {invoice.teamId ? invoice.teamName ?? invoice.name : invoice.name}
                </p>
              </Link>
            </td>
            <td>
              <Link to={`/office/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
                <p className="accountDetailsText">
                    {invoice.type === "multipleInvoice" ? "-" : invoice.email}
                </p>
              </Link>
            </td>
            <td>
              <Link to={`/office/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
                <p
                    className="quotewidth  accountDetailsStatus"
                    style={{
                    backgroundColor: INVOICESTATUS[invoice.status]
                        ? INVOICESTATUS[invoice.status][1]
                        : "",
                    }}
                >
                    {INVOICESTATUS[invoice.status]
                    ? INVOICESTATUS[invoice.status][0]
                    : invoice.status}
                </p>
              </Link>
            </td>
            <td>
              <Link to={`/office/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
                <p className="accountDetailsText accountDetailsLink">
                {invoice.teamId ? invoice.orders && invoice.orders.length
                    : invoice.orders[0].number}
                </p>
              </Link>
            </td>
            <td>
              <Link to={`/office/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
                <p className="accountDetailsText">
                    {formatTotal(invoice.totalPrice)}
                </p>
              </Link>
            </td>
            {(
            <td className="flex justify-center">
                <p className="quotewidth replied">
                {invoice.status === "paid" ? (
                    <CHECK />
                ) : (
                    <>
                    {showDetailModal ===
                        invoice.id + "paymentLink" && (
                        <div className="accountdetailHoverBox left-[-40px]">
                            <p
                            className="quotewidth"
                            style={{
                                textTransform: "capitalize",
                            }}
                            >
                            Share Payment Link
                            </p>
                        </div>
                        )}
                    <button
                        className="sendPaymentLink"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedSendPayment(invoice);
                        }}
                        onMouseOver={() =>
                        setShowDetailModal(
                            invoice.id + "paymentLink"
                        )
                        }
                        onMouseLeave={() =>
                        setShowDetailModal("")
                        }
                    >
                        <SEND />
                    </button>
                    </>
                )}
                </p>
            </td>
            )}
            <td onClick={(e) => e.stopPropagation()}>
            {/* {showDetailModal ===
                invoice.id + "download" + i && (
                <div className="accountdetailHoverBox left-[-40px]">
                    <p
                    className="quotewidth"
                    style={{
                        textTransform: "capitalize",
                    }}
                    >
                    Download Invoice
                    </p>
                </div>
                )} */}
            <DOWNLOAD className="hardCopyAddressIcon" 
            onClick={() => handleDownloadInvoice(invoice)}
            onMouseOver={() =>
                setShowDetailModal(
                invoice.id + "download"
                )
            }
            onMouseLeave={() =>
                setShowDetailModal("")
            }/>
            
            </td>
        </tr>
        )
      })}
    </tbody>
    )
  }

  return (
    <>
    <Configure filters={filters} hitsPerPage={20}/>

     <QueryFilters
        setFilterStartTimestamp={setFilterStartTimestamp}
        filterStartTimestamp={filterStartTimestamp}
        setFilterEndTimestamp={setFilterEndTimestamp}
        filterEndTimestamp={filterEndTimestamp}
        setDatePeriod={setDatePeriod}
        datePeriod={datePeriod}
        setStatusFilter={setPaymentFilter}
        statusFilter={paymentFilter}
        baseUrl="/office/invoices"
      />

    {openInvoiceModal && <OpenInvoiceModal type="invoice" order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}
    
    {selectedSendPayment !== "" && (
        <SendPaymentLinkPopUp
          data={selectedSendPayment}
          type={"invoice"}
          id={selectedSendPayment.id}
          onClose={() => setSelectedSendPayment("")}
        />
      )}

       <AccountNavBar
        windowSize={windowSize}
        selectedTab="invoices"
        accountMainPadding={false}
        admin={true}
      >
        <div className="accountMainTitleRow px-5 pt-5">
          <h2 className="accountMainTitle">Invoices</h2>
          
          <SearchBox classNames={{
            root: "newSearchbox",
            form: "newSearchbox_form",
            input: "newSearchbox_input",
            reset: "hidden",
            loadingIndicator: "hidden",
          }} 
          placeholder="Search By ID, Team, Email or Client" 
          submitIconComponent={() => <SEARCHICON/>} />
        </div>

         <div className="accountDetailsFiltersWrap m-0 px-4 w-full">
            <div className="relative sm:w-fit w-full">
              <div
                className="accountDetailsFilter"
                style={{
                  borderColor:
                    showFilter === "date" ||
                      filterStartTimestamp ||
                      filterEndTimestamp
                      ? "#12ABBF"
                      : "#E6E7E9",
                }}
                onClick={(e) => {
                  setShowFilter((f) => (f === "date" ? "" : "date"));
                }}
              >
                <DATE />
                <p className="accountDetailsFilterText">
                  {getSelectedDateText()}
                </p>
                {showFilter === "date" ? <UP /> : <DOWN />}
              </div>
              {showFilter === "date" && (
                <DateFilter
                  setShowModal={setShowFilter}
                  startTimestamp={filterStartTimestamp}
                  setStartTimestamp={setFilterStartTimestamp}
                  endTimestamp={filterEndTimestamp}
                  setEndTimestamp={setFilterEndTimestamp}
                  period={datePeriod}
                  setPeriod={setDatePeriod}
                  onMouseLeave={() => setShowFilter("")}
                />
              )}

              {/* <div className="relative">
                <div
                className="accountDetailsFilter"
                style={{
                    borderColor:
                    showFilter === "placedBy" || selectedUsers.length > 0
                        ? "#12ABBF"
                        : "#E6E7E9",
                }}
                onClick={(e) => {
                    setShowFilter((f) =>
                    f === "placedBy" ? "" : "placedBy"
                    );
                }}
                >
                <PLACEDBY />
                <p className="accountDetailsFilterText">
                    Teams{" "}
                    {selectedUsers.length > 0
                    ? ` (${selectedUsers.length}) `
                    : ""}
                </p>
                {showFilter === "placedBy" ? <UP /> : <DOWN />}
                </div>
                {showFilter === "placedBy" && (
                <Clientsfilter
                    setShowModal={setShowFilter}
                    clients={users}
                    setSelectedClients={setSelectedUsers}
                    selectedClients={selectedUsers}
                />
                )}
                </div> */}
            </div>

            <div style={{position: "relative"}}>
              <div className="accountDetailsFilter" style={{borderColor: (showFilter === "payment" || paymentFilter.length > 0) ? "#12ABBF" : "#E6E7E9"}} onClick={(e) => {setShowFilter(f => f === "payment" ? "" : "payment")}}>
                <STATUS/>
                <p className="accountDetailsFilterText">Status</p>
                {showFilter === "payment" ? <UP/> : <DOWN/>}
              </div>
              {showFilter === "payment" && <SearchFilter type="payment" setStatusFilter={setPaymentFilter} selectedFilters={paymentFilter} setShowModal={setShowFilter}/>}
            </div>

          </div>

        <div className="accountDetailsScroll w-full">
          {loading ? <NoData loadingText={"invoices"} loading={true} showBtn={false} type="order"/> :
          (!checkFetchAlgoliaData() ? localInvoices.length === 0 : hits.length === 0)  &&
          <NoData
            type="order"
            text={checkAnyFilterSelected() || query !== "" ? "Please select another filter" : ""}
            title={checkAnyFilterSelected() || query !== "" ? "No Invoice Matching This Filter": "You Don't Have Any Active Invoice Yet"}
            showBtn={false}
          /> }
          {(!checkFetchAlgoliaData() ? localInvoices.length > 0 : hits.length > 0) && !loading &&
          <table className="accountDetailsTable" style={{display: loading ? "none" : "table"}}>
           <thead>
            <tr>
                <th>
                <p className="accountDetailsHeading">ID</p>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Date</p>
                    { currentRefinement === "invoice_time_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("invoice_time_asc")}/> 
                    : currentRefinement === "invoice_time_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("invoice_time_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_time_dsc")}/>
                    }
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Client/Team Name</p>
                    {/* { selectedSort === "timestamp" ? 
                    <SORT className="sortIcon" onClick={() => setSelectedSort("timestamp")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => setSelectedSort("timestamp")}/>
                    } */}
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Client Email</p>
                    { currentRefinement === "invoice_email_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("invoice_email_asc")}/> 
                    : currentRefinement === "invoice_email_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("invoice_email_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_email_asc")}/>
                    }
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Status</p>
                    { currentRefinement === "invoice_status_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("invoice_status_asc")}/> 
                    : currentRefinement === "invoice_status_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("invoice_status_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_status_dsc")}/>
                    }
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Orders</p>
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Total</p>
                </div>
                </th>
                {userData && (
                <th>
                    <div className="accountData ">
                    <p className="accountDetailsHeading">Payment</p>
                    </div>
                </th>
                )}
                <th></th>
            </tr>
            </thead>

            <TableDataComponent hits={!checkFetchAlgoliaData() ? localInvoices : hits}/>

            </table>}
                {hits.length > 0 && 
                <Pagination
                padding={0}
                showFirst={false}
                showPrevious={true}
                showNext={true}
                showLast={false}
                classNames={{
                  root: "w-full my-4 mx-2",
                  list: "w-full flex justify-center items-center gap-2",
                  item: "",
                  selectedItem:"",
                  disabledItem:"opacity-50 cursor-not-allowed",
                  previousPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                  nextPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                  firstPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                  lastPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                }}
                translations={{
                previousPageItemText: 'Previous',
                nextPageItemText: 'Next',
                pageItemText: ({ currentPage, nbPages }) => `Page ${currentPage}`,
                previousPageItemAriaLabel: 'Go to previous page',
                nextPageItemAriaLabel: 'Go to next page',
                pageItemAriaLabel: ({ currentPage, nbPages }) => `Go to page ${currentPage} of ${nbPages}`,
              }}
                />}
        </div>
        
    </AccountNavBar>

    </>
  );
};

export default BackendInvoicesComponent;
